import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useConfig } from '../context/ConfigContext';
import api from '../api/axios';

export default function StaffQRGenerator() {
  const { config } = useConfig();
  const [stations, setStations] = useState([]);
  const [selectedStation, setSelectedStation] = useState('');
  const [points, setPoints] = useState('10');
  const [loading, setLoading] = useState(true);
  const [qrModalData, setQrModalData] = useState(null);
  const [selectedStage, setSelectedStage] = useState('');

  const FTP_BASE = 'https://ftp.pcnpublicidad.com/boehringer/concentrese';

  const toCapitalize = (str) => {
    if (!str || typeof str !== 'string') return '';
    return str
      .toLowerCase()
      .split(' ')
      .map(word => {
        if (!word) return '';
        if (['lego', 'f1', 'qr', 'bi', 'vip'].includes(word)) return word.toUpperCase();
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  };

  useEffect(() => {
    fetchStations();
  }, []);

  const fetchStations = async () => {
    try {
      const res = await api.get('/stations');
      setStations(res.data);
      if (res.data && res.data.length > 0) {
        const firstSt = res.data[0];
        setSelectedStation(firstSt.id.toString());
        setPoints(firstSt.points ? firstSt.points.toString() : '10');
        if (firstSt.has_stages && firstSt.stages && firstSt.stages.length > 0) {
          setSelectedStage(firstSt.stages[0].code || firstSt.stages[0].id.toString());
        } else {
          setSelectedStage('');
        }
      }
    } catch (err) {
      console.error('Error al cargar estaciones para el generador:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleStationChange = (e) => {
    const stationId = e.target.value;
    setSelectedStation(stationId);
    const found = stations.find(st => st.id.toString() === stationId);
    if (found) {
      setPoints(found.points ? found.points.toString() : '10');
      if (found.has_stages && found.stages && found.stages.length > 0) {
        setSelectedStage(found.stages[0].code || found.stages[0].id.toString());
      } else {
        setSelectedStage('');
      }
    }
  };

  const currentStationObj = stations.find(st => st.id.toString() === selectedStation);

  const handleGenerate = (e) => {
    e.preventDefault();
    if (!selectedStation) {
      alert('Por favor seleccione una estación.');
      return;
    }

    const stationObj = currentStationObj;
    const destrezaPoints = parseInt(points, 10) || 0;

    let qrString = `station=${stationObj ? stationObj.code || stationObj.id : selectedStation}`;
    if (stationObj && stationObj.has_stages && selectedStage) {
      qrString += `|stage=${selectedStage}`;
    }
    if (destrezaPoints > 0) {
      qrString += `|destreza=${destrezaPoints}`;
    }

    const selectedStageObj = stationObj && stationObj.stages ? stationObj.stages.find(sg => (sg.code || sg.id.toString()) === selectedStage) : null;

    setQrModalData({
      stationName: stationObj ? toCapitalize(stationObj.name) : `Estación ${selectedStation}`,
      stageName: selectedStageObj ? toCapitalize(selectedStageObj.name) : null,
      participationPoints: stationObj ? stationObj.participation_points || 5 : 5,
      skillPoints: destrezaPoints,
      totalPoints: (stationObj ? stationObj.participation_points || 5 : 5) + destrezaPoints,
      qrValue: qrString
    });
  };

  return (
    <div
      className="min-h-screen bg-[#07241c] text-white flex flex-col items-center p-4 sm:p-6 space-y-6 bg-cover bg-center"
      style={{ backgroundImage: `url(${FTP_BASE}/fondo.png)` }}
    >
      <div className="w-full max-w-2xl space-y-6">
        {/* Header */}
        <div className="bg-[#0b382c]/90 border-2 border-[#00e676]/50 rounded-3xl p-6 sm:p-8 shadow-2xl space-y-3 backdrop-blur-md">
          <div className="flex items-center gap-2">
            <span className="bg-[#00e676]/20 text-[#00e676] border border-[#00e676]/40 text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest">
              Perfil Staff
            </span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-black text-white tracking-tight uppercase">
            Generador de Código QR de Puntos
          </h1>
          <p className="text-xs sm:text-sm text-slate-200 font-medium leading-relaxed">
            Seleccione la estación correspondiente, indique la etapa si aplica y especifique los puntos por destreza obtenidos.
          </p>
        </div>

        {/* Form Card */}
        <div className="bg-[#0b382c]/90 rounded-3xl p-6 sm:p-8 shadow-2xl border-4 border-[#00e676]/60 backdrop-blur-md space-y-6">
          {loading ? (
            <div className="py-8 text-center text-slate-300 font-bold">
              Cargando estaciones disponibles...
            </div>
          ) : (
            <form onSubmit={handleGenerate} className="space-y-6">
              <div>
                <label className="block text-xs font-black text-[#00e676] uppercase tracking-widest mb-2">
                  Seleccionar Estación del Circuito
                </label>
                <select
                  value={selectedStation}
                  onChange={handleStationChange}
                  className="w-full bg-[#07241c] border-2 border-[#00e676]/40 text-white text-sm rounded-2xl p-4 focus:ring-2 focus:ring-[#00e676] focus:outline-none transition-all font-bold"
                >
                  {stations.map(st => (
                    <option key={st.id} value={st.id} className="bg-[#07241c] text-white">
                      {toCapitalize(st.name)} {st.has_stages ? '(Con Etapas)' : ''} - Cód: {st.code}
                    </option>
                  ))}
                </select>
              </div>

              {currentStationObj && currentStationObj.has_stages && currentStationObj.stages && currentStationObj.stages.length > 0 && (
                <div>
                  <label className="block text-xs font-black text-amber-300 uppercase tracking-widest mb-2">
                    Seleccionar Etapa / Día de la Estación
                  </label>
                  <select
                    value={selectedStage}
                    onChange={(e) => setSelectedStage(e.target.value)}
                    className="w-full bg-[#07241c] border-2 border-amber-400/40 text-amber-300 text-sm rounded-2xl p-4 focus:ring-2 focus:ring-amber-400 focus:outline-none transition-all font-bold"
                    required
                  >
                    {currentStationObj.stages.map(sg => (
                      <option key={sg.id} value={sg.code || sg.id.toString()} className="bg-[#07241c] text-amber-300">
                        {toCapitalize(sg.name)} (Cód: {sg.code})
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-xs font-black text-slate-200 uppercase tracking-widest">
                    Ingresar Puntos por Destreza / Aciertos (Opcional)
                  </label>
                  <button
                    type="button"
                    onClick={() => setPoints('0')}
                    className="text-xs font-black text-[#00e676] hover:text-white bg-[#07241c] px-3 py-1 rounded-xl border border-[#00e676]/40 transition-all shadow-sm"
                  >
                    🎯 Solo Participación (0 destreza)
                  </button>
                </div>
                <input
                  type="number"
                  min="0"
                  max="1000"
                  value={points}
                  onChange={e => setPoints(e.target.value)}
                  placeholder="0"
                  className="w-full bg-[#07241c] border-2 border-[#00e676]/40 text-[#00e676] text-lg rounded-2xl p-4 focus:ring-2 focus:ring-[#00e676] focus:outline-none transition-all font-black shadow-inner"
                  required
                />
                <p className="text-xs text-slate-300 mt-2 font-medium">
                  * Importante: Al escanear este QR se otorgarán automáticamente los <strong className="text-[#00e676]">5 puntos de participación fijos</strong> de la estación, incluso si el puntaje de destreza es 0.
                </p>
              </div>

              <button
                type="submit"
                className="w-full py-4 bg-[#00e676] hover:bg-[#00c853] text-[#07241c] font-black text-sm uppercase tracking-widest rounded-2xl shadow-xl hover:scale-[1.02] active:scale-95 transition-all flex items-center justify-center gap-2"
              >
                <span>✨</span> GENERAR CÓDIGO QR
              </button>
            </form>
          )}
        </div>
      </div>

      {/* QR Output Modal */}
      {qrModalData && (
        <div className="fixed inset-0 z-[99999] overflow-y-auto bg-black/85 backdrop-blur-md flex items-center justify-center p-4">
          <div className="bg-[#0b382c] border-2 border-[#00e676] rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden transform transition-all animate-fadeIn text-center">
            
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#00e676]/30 bg-[#07241c] text-white">
              <h3 className="text-sm font-black uppercase tracking-wider text-[#00e676]">Código QR Generado</h3>
              <button
                onClick={() => setQrModalData(null)}
                className="text-slate-300 hover:text-white p-1 rounded-full hover:bg-white/10 transition-colors text-lg font-black"
              >
                ✕
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 space-y-4">
              <div>
                <span className="bg-[#00e676]/20 text-[#00e676] border border-[#00e676]/40 text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-wider block w-max mx-auto mb-2">
                  {qrModalData.stationName}
                </span>
                {qrModalData.stageName && (
                  <span className="bg-amber-400/20 text-amber-300 border border-amber-400/40 text-[10px] font-black px-2.5 py-0.5 rounded-full uppercase tracking-wider block w-max mx-auto mt-1">
                    Etapa: {qrModalData.stageName}
                  </span>
                )}
              </div>

              {/* QR Code Render Box */}
              <div className="p-4 bg-white border-4 border-[#00e676] rounded-3xl inline-block shadow-2xl my-2">
                <QRCodeSVG
                  value={qrModalData.qrValue}
                  size={210}
                  level="H"
                  includeMargin={true}
                />
              </div>

              <button
                onClick={() => setQrModalData(null)}
                className="w-full py-3.5 bg-[#00e676] text-[#07241c] font-black text-xs uppercase tracking-widest rounded-2xl hover:bg-[#00c853] transition-all"
              >
                CERRAR VENTANA
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

